export default {
  en: {
    PackageCodeRegistryIndexScene: {
      title: 'Package code registry',
    },
  },
};
